import _ from 'lodash'
import SubProductModel from './sub-product'

export default class ProductModel {
  id

  code

  name

  price

  available

  thumbUrl

  wholesalePrice

  wholesalePrice2

  wholesalePrice3

  wholesalePrice4

  wholesalePrice5

  wholesalePrice6

  wholesalePrice7

  wholesalePrice8

  wholesalePrice9

  wholesalePrice10

  options

  unitPrice

  salePrice

  constructor (item = {}) {
    this.id = item.id
    this.name = item.name || ''
    this.code = item.code || ''
    this.price = item.price || 0
    this.available = item.available || 0
    this.thumbUrl = item.thumbUrl || item.pictureUrl
    this.wholesalePrice = item.wholesalePrice || 0
    this.wholesalePrice2 = item.wholesalePrice2 || 0
    this.wholesalePrice3 = item.wholesalePrice3 || 0
    this.wholesalePrice4 = item.wholesalePrice4 || 0
    this.wholesalePrice5 = item.wholesalePrice5 || 0
    this.wholesalePrice6 = item.wholesalePrice6 || 0
    this.wholesalePrice7 = item.wholesalePrice7 || 0
    this.wholesalePrice8 = item.wholesalePrice8 || 0
    this.wholesalePrice9 = item.wholesalePrice9 || 0
    this.wholesalePrice10 = item.wholesalePrice10 || 0
    this.unitPrice = item.unitPrice
    this.salePrice = this.calcUnitPrice(item, item.unitPrice)
    this.options = item.subproducts?.map((subproduct) => {
      const salePrice = this.calcUnitPrice(subproduct, item.unitPrice)
      return new SubProductModel({
        ...subproduct,
        salePrice
      })
    })
  }

  calcUnitPrice = (item, unit) => {
    if (_.isNumber(unit)) {
      if (unit === 1) {
        return this.wholesalePrice || item.price
      } if (unit > 1 && unit < 11) {
        return this[`wholesalePrice${unit}`] || item.price
      }
    }
    return item.price
  }
}
